module.exports = __webpack_public_path__ + "UX13.png?b07df4a120144ca67f98c7ce452e8d53";


//////////////////
// WEBPACK FOOTER
// ./src/assets/UX13.png
// module id = 62
// module chunks = 0